import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ad751f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-input" }
const _hoisted_2 = { "aria-live": "assertive" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "ファイルをアップロード", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ここにファイルをドラッグ&ドロップ ")
const _hoisted_5 = { class: "navigation" }
const _hoisted_6 = { class: "navigation-button" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " 戻る ", -1))
const _hoisted_8 = { class: "navigation-button" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " 進む ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_InputImageFile = _resolveComponent("InputImageFile")!
  const _component_OuterContentsFile = _resolveComponent("OuterContentsFile")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
        return (_openBlock(), _createBlock(_component_Message, {
          key: message.id,
          id: message.id,
          type: message.type,
          text: message.text,
          isDisplay: _ctx.isDisplay,
          onRemove: _ctx.removeMessage
        }, null, 8, ["id", "type", "text", "isDisplay", "onRemove"]))
      }), 128))
    ]),
    _hoisted_3,
    _createVNode(_component_InputImageFile, {
      onInputImage: _ctx.fileUpload,
      isThumbnailDisplay: false,
      accept: [],
      isShadow: false,
      class: "the-image-search-on-top-page-main"
    }, {
      placeholder: _withCtx(() => [
        _createVNode(_component_DssIcon, { icon: "file" }),
        _hoisted_4
      ]),
      _: 1
    }, 8, ["onInputImage"]),
    _createVNode(_component_OuterContentsFile, {
      fileList: _ctx.uploadFileList,
      "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.uploadFileList) = $event))
    }, null, 8, ["fileList"]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_AppButton, {
          onClick: _ctx.prev,
          onKeydown: _withKeys(_withModifiers(_ctx.prev, ["prevent"]), ["space","enter"]),
          buttonId: 'button-back'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DssIcon, {
              icon: "arrow-left",
              style: {"font-size":"18px"}
            }),
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick", "onKeydown"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_AppButton, {
          onClick: _ctx.next,
          onKeydown: _withKeys(_withModifiers(_ctx.next, ["prevent"]), ["space","enter"]),
          styled: 'is-accent',
          disabled: _ctx.uploadFileList.length === 0,
          buttonId: 'button-next'
        }, {
          default: _withCtx(() => [
            _hoisted_9,
            _createVNode(_component_DssIcon, {
              icon: "arrow-right",
              style: {"font-size":"18px"}
            })
          ]),
          _: 1
        }, 8, ["onClick", "onKeydown", "disabled"])
      ])
    ])
  ]))
}